import React from "react";
import BLACKBOOKImg from "assets/img/ls-pp-logo.png";

// Define the BLACKBOOK component
const BLACKBOOK = () => {
	// Function to open the OFAC search URL in a new tab securely
	const openInNewTab = () => {
		const newWindow = window.open(
			"https://www.blackbookpricepoint.com/Account/Login.aspx",
			"_blank",
			"noopener,noreferrer"
		);
		if (newWindow) newWindow.opener = null;
	};

	return (
		<div onClick={openInNewTab}>
			<img src={BLACKBOOKImg} alt="BLACK BOOK" style={{ cursor: "pointer" }} />
		</div>
	);
};

export default BLACKBOOK;
